import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, User } from "lucide-react";
import emproLogo from "@/assets/empro-logo.png";
import { useCart } from "@/lib/shop";
import { useShopAuth } from "@/lib/shopAuth";
import ShopAssistant from "@/components/shop/ShopAssistant";
import NewsletterPopup from "@/components/shop/NewsletterPopup";

export default function ShopLayout({ children }) {
  const { count } = useCart();
  const auth = useShopAuth();
  const customer = auth?.customer;
  const { pathname } = useLocation();
  const onGallery = pathname.startsWith("/sklep/realizacje");

  return (
    <div className="min-h-screen bg-[#0D1117] text-neutral-100 flex flex-col">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0D1117]/90 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 h-16 flex items-center justify-between gap-4">
          <Link to="/sklep" data-testid="shop-logo" className="flex items-center gap-3">
            <img src={emproLogo} alt="EMPRO" className="h-8 w-auto" />
            <span className="font-display font-extrabold uppercase tracking-tight text-lg">Sklep</span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-4">
            <nav className="flex items-center gap-1 rounded-full bg-white/5 p-1" data-testid="shop-nav">
              <Link to="/sklep" data-testid="shop-nav-shop" className={`rounded-full px-3 sm:px-4 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${!onGallery ? "bg-amber-400 text-[#0D1117]" : "text-neutral-300 hover:text-amber-400"}`}>Sklep</Link>
              <Link to="/sklep/realizacje" data-testid="shop-nav-gallery" className={`rounded-full px-3 sm:px-4 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${onGallery ? "bg-amber-400 text-[#0D1117]" : "text-neutral-300 hover:text-amber-400"}`}>Realizacje</Link>
            </nav>
            <Link to="/sklep/konto" data-testid="shop-account-link"
              className="flex items-center gap-2 text-sm font-semibold text-neutral-200 hover:text-amber-400 transition-colors">
              <User className="h-4 w-4" />{customer ? (customer.name?.split(" ")[0] || "Konto") : "Zaloguj"}
            </Link>
            <Link to="/sklep/koszyk" data-testid="shop-cart-link"
              className="relative flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2 text-[#0D1117] font-bold text-sm hover:bg-amber-300 transition-colors">
              <ShoppingCart className="h-4 w-4" />Koszyk
              {count > 0 && <span data-testid="shop-cart-count" className="absolute -top-2 -right-2 grid h-5 min-w-5 place-items-center rounded-full bg-rose-500 px-1 text-[11px] font-bold text-white">{count}</span>}
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-white/10 bg-black/40 mt-16">
        <div className="mx-auto max-w-7xl px-4 py-10 grid gap-8 sm:grid-cols-3 text-sm">
          <div>
            <img src={emproLogo} alt="EMPRO" className="h-9 w-auto mb-3" />
            <p className="text-neutral-400 leading-relaxed">EMPRO Marcin Masny<br />ul. Targowa 60, 08-400 Garwolin<br />NIP 826-15-44-909</p>
          </div>
          <div>
            <p className="font-bold uppercase tracking-wider text-xs text-amber-400 mb-3">Informacje</p>
            <ul className="space-y-2 text-neutral-300">
              <li><Link to="/sklep/regulamin" data-testid="footer-regulamin" className="hover:text-amber-400">Regulamin sklepu</Link></li>
              <li><Link to="/sklep/polityka-prywatnosci" data-testid="footer-privacy" className="hover:text-amber-400">Polityka prywatności (RODO)</Link></li>
              <li><Link to="/sklep/odstapienie" data-testid="footer-withdrawal" className="hover:text-amber-400">Prawo odstąpienia od umowy</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-bold uppercase tracking-wider text-xs text-amber-400 mb-3">Kontakt</p>
            <p className="text-neutral-300">E-mail: biuro@empro.pro</p>
            <p className="text-neutral-500 text-xs mt-4">© {new Date().getFullYear()} EMPRO. Wszelkie prawa zastrzeżone.</p>
          </div>
        </div>
      </footer>
      <ShopAssistant />
      <NewsletterPopup />
    </div>
  );
}
